// Shared SVG geometry for brand components.
// Path data and viewBox values are copied verbatim from the SVG masters in
// packages/brand-assets/adva/{mark,wordmark}/ so inline components render
// pixel-identically.

export const MARK_VIEWBOX = "0 0 100 100";
export const MARK_PATH =
  "M 41 8 L 59 8 L 96 94 L 4 94 Z M 36.3 19 L 68.6 94 L 37 94 L 40.9 72 L 52.3 72 L 32.9 27 Z";

export const WORDMARK_VIEWBOX = "0 0 3488 814";
export const WORDMARK_PATH =
  "M161 765 361 65H551L750 765H639L593 600H319L273 765ZM346 500H566L464 132H448Z M1039 765V669H1133V161H1039V65H1319Q1459 65 1533.5 136Q1608 207 1608 350V481Q1608 624 1533.5 694.5Q1459 765 1319 765ZM1242 667H1320Q1411 667 1455 621Q1499 575 1499 484V346Q1499 254 1455 209Q1411 164 1320 164H1242Z M2093 765 1898 65H2010L2180 697H2193L2362 65H2474L2280 765Z M2737 765 2937 65H3127L3326 765H3215L3169 600H2895L2849 765ZM2922 500H3142L3040 132H3024Z";

export const LOCKUP_HORIZONTAL_VIEWBOX = "0 0 3344 1000";
export const LOCKUP_HORIZONTAL_MARK_TRANSFORM = "translate(240, 0) scale(10)";
export const LOCKUP_HORIZONTAL_WORDMARK_TRANSFORM =
  "translate(1399.5, 302.5) scale(0.5)";

export const LOCKUP_STACKED_VIEWBOX = "0 0 3488 1820";
export const LOCKUP_STACKED_MARK_TRANSFORM = "translate(1244, 120) scale(10)";
export const LOCKUP_STACKED_WORDMARK_TRANSFORM =
  "translate(1046.6, 1314) scale(0.4)";
